// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 544px) {
  p {font-size:1.5rem;} /*1rem = 16px*/
  .nav-item svg{height: 4em;}
  .navbar a {font-size: 1.5rem;}
}

@media (min-width: 992px) {
  p {font-size:1rem;} /*1rem = 16px*/
  .nav-item svg{height: 2rem;}
  .navbar a {font-size: 1rem;}
}
`, "",{"version":3,"sources":["webpack://./css/Page.css"],"names":[],"mappings":"AAAA;EACE,GAAG,gBAAgB,CAAC,EAAE,cAAc;EACpC,cAAc,WAAW,CAAC;EAC1B,WAAW,iBAAiB,CAAC;AAC/B;;AAEA;EACE,GAAG,cAAc,CAAC,EAAE,cAAc;EAClC,cAAc,YAAY,CAAC;EAC3B,WAAW,eAAe,CAAC;AAC7B","sourcesContent":["@media (min-width: 544px) {\r\n  p {font-size:1.5rem;} /*1rem = 16px*/\r\n  .nav-item svg{height: 4em;}\r\n  .navbar a {font-size: 1.5rem;}\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  p {font-size:1rem;} /*1rem = 16px*/\r\n  .nav-item svg{height: 2rem;}\r\n  .navbar a {font-size: 1rem;}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
